/**
 * Os dois blocos de montagem das seções do formulário do protocolo (E74.F1):
 * o `fieldset` com título e o campo de texto controlado. Extraídos de
 * `ProtocoloFormSecoes` na E93.F1, quando os campos da URL de verificação e da
 * frase do tipo de assinatura levaram aquele arquivo acima do teto de linhas.
 */
import type { ReactNode } from 'react';

import { Field, Input } from '@/components/ui';

export function Secao({ titulo, children }: { titulo: string; children: ReactNode }) {
  return (
    <fieldset className="min-w-0">
      <legend className="mb-sc-2 font-titulo text-[13px] uppercase tracking-[0.06em] text-fg-muted">
        {titulo}
      </legend>
      <div className="grid gap-sc-3 sm:grid-cols-2">{children}</div>
    </fieldset>
  );
}

interface CampoTextoProps {
  id: string;
  label: string;
  value: string;
  onChange: (valor: string) => void;
  disabled: boolean;
  hint?: string;
  error?: string;
  mono?: boolean;
  type?: string;
  inputMode?: 'numeric' | 'decimal' | 'email' | 'tel';
  maxLength?: number;
  colSpan?: 'full';
}

export function CampoTexto(props: CampoTextoProps) {
  const { id, label, value, onChange, disabled, hint, error, mono, type, colSpan } = props;
  return (
    <Field
      htmlFor={id}
      label={label}
      {...(hint !== undefined ? { description: hint } : {})}
      {...(error !== undefined ? { error } : {})}
      {...(colSpan === 'full' ? { className: 'sm:col-span-2' } : {})}
    >
      <Input
        id={id}
        data-testid={id}
        value={value}
        disabled={disabled}
        type={type ?? 'text'}
        onChange={(e) => onChange(e.target.value)}
        {...(mono ? { className: 'font-mono' } : {})}
        {...(props.inputMode !== undefined ? { inputMode: props.inputMode } : {})}
        {...(props.maxLength !== undefined ? { maxLength: props.maxLength } : {})}
      />
    </Field>
  );
}
